var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMifcomLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MIFCOM_Logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 147.605,
    height: 30.845,
    viewBox: "0 0 147.605 30.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_13",
    "data-name": "Gruppe 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_27",
    "data-name": "Pfad 27",
    d: "M46.344,4.293H38.58L15.5,27.375v7.764Z",
    transform: "translate(-15.499 -4.293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_28",
    "data-name": "Pfad 28",
    d: "M89.126,4.293H81.362L58.28,27.375v7.764Z",
    transform: "translate(-41.02 -4.293)",
    fill: "#d70010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_29",
    "data-name": "Pfad 29",
    d: "M131.907,4.293h-7.764L101.061,27.375v7.764Z",
    transform: "translate(-66.541 -4.293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_30",
    "data-name": "Pfad 30",
    d: "M195.413,26.734h2.649V39.89h-2.43V30.242l-4.988,5.938-5.006-5.938V39.89h-2.412V26.734h2.631l4.787,5.7Z",
    transform: "translate(-115.555 -17.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_31",
    "data-name": "Pfad 31",
    d: "M356.764,26.734h2.649V39.89h-2.43V30.242l-4.988,5.938-5.007-5.938V39.89h-2.412V26.734h2.631l4.787,5.7Z",
    transform: "translate(-211.809 -17.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_32",
    "data-name": "Pfad 32",
    d: "M309.967,36.959V29.274a.124.124,0,0,1,.128-.128h7.685l1.905-1.906a2.524,2.524,0,0,0-1.513-.507h-8.076a2.534,2.534,0,0,0-2.54,2.54V37.35a2.531,2.531,0,0,0,.5,1.517Z",
    transform: "translate(-189.724 -17.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_33",
    "data-name": "Pfad 33",
    d: "M320.072,31.8v7.351a.123.123,0,0,1-.11.128h-7.369l-2.036,2.036a2.53,2.53,0,0,0,1.328.376h8.076a2.546,2.546,0,0,0,2.54-2.54V31.07a2.515,2.515,0,0,0-.378-1.326Z",
    transform: "translate(-191.515 -19.476)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_34",
    "data-name": "Pfad 34",
    d: "M239.323,29.146h8.618L248.99,28.1V26.734h-12.1V39.89h2.43V34.518h7.784V32.106h-7.784Z",
    transform: "translate(-147.571 -17.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_35",
    "data-name": "Pfad 35",
    d: "M266.876,32.712h0Z",
    transform: "translate(-165.457 -21.247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_36",
    "data-name": "Pfad 36",
    d: "M283.117,37.478h-9.448a.125.125,0,0,1-.128-.128V29.274a.125.125,0,0,1,.128-.128h9.609l.971-.971V26.734h-10.58a2.535,2.535,0,0,0-2.54,2.54V37.35a2.535,2.535,0,0,0,2.54,2.54h10.58V38.61Z",
    transform: "translate(-167.993 -17.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_37",
    "data-name": "Pfad 37",
    d: "M227.574,28.694v-1.96h-2.412v4.372Z",
    transform: "translate(-140.572 -17.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_38",
    "data-name": "Pfad 38",
    d: "M225.162,37.364v7.429h2.412V34.952Z",
    transform: "translate(-140.572 -22.582)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMifcomLogo);
export default __webpack_public_path__ + "static/media/MIFCOM_Logo.1479ac9344e414de84475e13d003a351.svg";
export { ForwardRef as ReactComponent };